import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";
import styled from "styled-components";

import bigGreenOvalSrc from "../../assets/images/big-filled-green-oval.png";
import caterpillarBackgroundSrc from "../../assets/images/bulldozerBackground.svg";
import caterpillarSrc from "../../assets/images/caterpillar.png";

import { SHOPIFY_URL } from "../../utils/shopify.utils";
import ContainedButton from "../../components/Buttons/ContainedButton";
import {
  BackgroundImageContainer,
  SlideContainer as Container,
  Paragraph,
  RegularGreenOval,
  Title,
} from "./OurCommitment.styles";

const SlideContainer = styled(Container)`
  margin-right: 145px;
  min-width: 1200px;
`;

const StyledTitle = styled(Title)`
  margin-top: 0;
  width: 640px;
  color: white;
  font-size: 55px;
  font-family: "noto-sans", sans-serif;
  font-weight: 66;
`;

const StyledParagraph = styled(Paragraph)`
  padding-top: 1.5rem;
  margin: 0;
`;

const OurCommitmentSlide3 = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <SlideContainer>
      <BackgroundImageContainer>
        <div>
          <CaterpillarBackground />
          <Caterpillar />
        </div>
        <BigGreenLeaf />
      </BackgroundImageContainer>

      <CollectiveEffort theme={theme}>
        <StyledTitle theme={theme}>{t("It's A Collective Effort")}</StyledTitle>
        <StyledParagraph theme={theme} style={{ color: "white" }}>
          {t(
            "At evrbed we believe in Quality over Quantity, Durable over Consumable, and Innovation over the Status Quo."
          )}
        </StyledParagraph>
        <StyledParagraph theme={theme} style={{ color: "white" }}>
          {t(
            "That's why we have committed ourselves to recycling every single mattress and component we produce. When you replace a component, simply return the used one to us and we will ensure its fully recycled. Better yet- when you purchase a new evrbed, we will take your old mattress away for recycling, hassle free."
          )}
        </StyledParagraph>
        <StyledParagraph theme={theme} style={{ color: "white" }}>
          {t(
            "Preserving the environment is a collective effort and we are proud to be a contributor. We have committed to monthly donations into the research that further advances technologies that reduce human impact on the environment. This is how we take things one step further than others to ensure we’re prepared for the next challenge."
          )}
        </StyledParagraph>
        <ButtonContainer>
          <LearnMore />
          <RecyclingHelp />
        </ButtonContainer>
      </CollectiveEffort>
      <BackgroundImageContainer>
        <NotFilledGreenOval />
      </BackgroundImageContainer>
    </SlideContainer>
  );
};

const LearnMore = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Link to={"/learn-more"}>
      <StyledContainedButton
        color={theme.COLORS.GREEN.lightGreen}
        fontColor={theme.COLORS.WHITE.backgroundWhite}
        variant={"contained"}
        onClick={() => {
          return (window.top.location.href =
            SHOPIFY_URL + "pages/shipping-delivery2");
        }}
        styles={{
          border: "2px white solid",
          fontSize: "1rem",
          height: "53px",
          width: "161px",
        }}
      >
        {t("Learn More")}
      </StyledContainedButton>
    </Link>
  );
};

const RecyclingHelp = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Link to={"/learn-more"}>
      <StyledContainedButton
        color={theme.COLORS.GREEN.green}
        fontColor={theme.COLORS.BLUE.blue}
        variant={"contained"}
        onClick={() => {}}
        styles={{
          fontSize: "1rem",
          height: "51px",
          width: "180px",
        }}
      >
        {t("RECYCLING HELP")}
      </StyledContainedButton>
    </Link>
  );
};

const Caterpillar = styled.img.attrs({
  src: caterpillarSrc,
})`
  border-radius: 60px;
  //box-shadow: 0px 0px 40px #00000014;
  height: 670px;
  margin-left: -345px;
  margin-top: -80px;
  position: absolute;
  width: 690px;
  z-index: 10;
`;
const CaterpillarBackground = styled.img.attrs({
  src: caterpillarBackgroundSrc,
})`
  border-radius: 60px;
  //box-shadow: 0px 0px 40px #00000014;
  height: 780px;
  margin-left: -395px;
  margin-top: -140px;
  position: absolute;
  width: 780px;
  z-index: 10;
`;

const BigGreenLeaf = styled.img.attrs({
  src: bigGreenOvalSrc,
})`
  height: 863px;
  margin-left: 160px;
  margin-top: -50px;
  position: absolute;
  width: 1076px;
  z-index: 10;
`;

const CollectiveEffort = styled.div`
  height: 863px;
  margin-left: 360px;
  margin-top: 35px;
  position: relative;
  width: 780px;
  z-index: 20;
`;

const NotFilledGreenOval = styled(RegularGreenOval)`
  height: 295px;
  margin-left: 0;
  margin-top: -630px;
  position: relative;
  transform: scaleX(-1);
  width: 257px;
  z-index: 20;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: max-content;
`;

const StyledContainedButton = styled(ContainedButton)`
  margin-top: 30px;
  padding-right: 1rem;
`;
export default OurCommitmentSlide3;
